import ServiceOperationSettingHistory from '../../../../../components/units/Management/AiAgent/Operation/History';

export default function AiAgentServiceOperationSettingHistoryPage() {
  return <ServiceOperationSettingHistory />;
}
